/**
 * PostHog Analytics Event Constants
 * Centralized event name definitions for type safety and consistency
 */

/** Super property on every event, so the shared PostHog project can tell lidz_front apart from the backoffice. */
export const ANALYTICS_APP = 'lidz_front';

/** PostHog group type that aggregates users and their events by Lidz project. */
export const PROJECT_GROUP_TYPE = 'project';

/**
 * Always-open "Feedback abierto" API survey, rendered by the Feedback page.
 * The id defaults to production; a local .env points it at the Lidz-Local-Development copy, which keeps the question id.
 */
export const FEEDBACK_SURVEY = {
  id: import.meta.env.VITE_PUBLIC_POSTHOG_FEEDBACK_SURVEY_ID || '01a18309-6de3-0000-9f9d-d4c194d1d5f5',
  name: 'Feedback abierto (pestaña Feedback)',
  questionId: '6f336d78-ac5b-429a-9558-f218f54f6f0d',
  question: '¿Qué nos quieres contar?',
  contactQuestionId: '24e423e0-fd46-4c19-85fa-6b33046a6d77',
  contactQuestion: '¿Te podemos contactar para entender mejor tu comentario?',
};

/** Router state on the sidebar's Funnel/Chat/Tabla links, so the funnel can tell a sidebar click from a deep link. */
export const SIDEBAR_VIEW_NAVIGATION_STATE = { viewChangeTrigger: 'sidebar' } as const;

export const ANALYTICS_EVENTS = {
  NOTIFICATION_CENTER_TOGGLED: 'nc_toggled',
  NOTIFICATION_CENTER_ACTION_USED: 'nc_action_used',
  CLIENT_CARD_CHAT_OPENED: 'client_card_chat_opened',
  CLIENT_DETAILS_OPENED: 'client_details_opened',
  CLIENT_DETAILS_TAB_VIEWED: 'client_details_tab_viewed',
  CLIENT_MORE_INFO_OPENED: 'client_more_info_opened',
  CLIENT_STAGE_MANUALLY_CHANGED: 'client_stage_manually_changed',
  FUNNEL_VIEW_CHANGED: 'funnel_view_changed',
  FUNNEL_VIEW_EXITED: 'funnel_view_exited',
  FUNNEL_TABLE_LEGACY_VIEW_REQUESTED: 'funnel_table_legacy_view_requested',
  USER_LOGGED_IN: 'user_logged_in',
  USER_LOGGED_OUT: 'user_logged_out',
  CALL_PERMISSION_REQUESTED: 'call_permission_requested',
  CALL_INITIATED: 'call_initiated',
  CALL_TERMINATED: 'call_terminated',
  MESSAGE_SENT: 'message_sent',
  TEMPLATE_SENT: 'template_sent',
  TEMPLATE_SCHEDULED: 'template_scheduled',
  BULK_TEMPLATE_SENT: 'bulk_template_sent',
  BULK_TEMPLATE_SCHEDULED: 'bulk_template_scheduled',
  TEMPLATE_CREATED: 'template_created',
  TEMPLATE_DELETED: 'template_deleted',
  TEMPLATE_CATALOG_UPDATED: 'template_catalog_updated',
  SCHEDULED_TEMPLATE_CANCELLED: 'scheduled_template_cancelled',
  BULK_TEMPLATE_CANCELLED: 'bulk_template_cancelled',
  CLIENT_NOTE_CREATED: 'client_note_created',
  CLIENT_OPENED_FROM_CRM: 'client_opened_from_crm',
  CLIENT_UPDATED: 'client_updated',
  CLIENT_AI_DISABLED: 'client_ai_disabled',
  CLIENT_AI_ENABLED: 'client_ai_enabled',
  CLIENTS_ASSIGNED: 'clients_assigned',
  CLIENTS_BULK_MOVED: 'clients_bulk_moved',
  CLIENTS_BULK_IMPORTED: 'clients_bulk_imported',
  CLIENTS_FILTERED: 'clients_filtered',
  CLIENTS_SEARCHED: 'clients_searched',
  SESSION_EXPIRED: 'session_expired',
} as const;

/**
 * Type for all event names
 */
export type AnalyticsEventName = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];
